import { ReactComponent as PlusSvg } from '../../assets/icons/plus.svg';

export const PlusIcon: SvgIcon = (props) => {
    return <PlusSvg {...props} />;
};
